// Components
import WantToReadButton from "../react_components/want_to_read/want_to_read_button";
import WantToReadWithStars from "../react_components/want_to_read/want_to_read_with_stars";

// Stores
import ShelvingsStore from "../react_stores/shelvings_store";
import UserShelvesStore from "../react_stores/user_shelves_store";
import UserAgentCapabilitiesStore from "../react_stores/user_agent_capabilities_store";

export const WantToReadComponents = {
  WantToReadButton,
  WantToReadWithStars,
};

export const WantToReadStores = {
  ShelvingsStore,
  UserShelvesStore,
  UserAgentCapabilitiesStore,
};
